import { Controller } from '@hotwired/stimulus'

import 'semantic-ui-checkbox/checkbox.min'
import 'semantic-ui-css/components/checkbox.min.css'
import 'semantic-ui-css/components/checkbox.css'
import 'semantic-ui-dropdown/dropdown.min'
import 'semantic-ui-dropdown/dropdown.min.css'
import 'semantic-ui-css/components/transition.min.css'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'
import { getTimeFormat } from '../../utils/utils'
import { dispatchCustomEvent } from "../../modules/utils/DispatchCustomEvent";

global.moment = require('moment')
require('tempusdominus-bootstrap-4')
$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'far fa-arrow-up',
    down: 'far fa-arrow-down',
    previous: 'far fa-chevron-left',
    next: 'far fa-chevron-right',
    today: 'far fa-calendar-check-o',
    clear: 'far fa-trash',
    close: 'far fa-check'
  }
})

export default class extends Controller {
  static values = {
    isRepeatTimings: Boolean
  }

  static targets = [
    'eventStartDate', 'eventEndDate', 'activateAt', 'applyToAllDays', 'applyToAllDaysCheckbox',
    'timings'
  ]

  setupStartDatePicker () {
    $(this.eventStartDateTarget).datetimepicker({
      focusOnShow: false,
      toolbarPlacement: 'bottom',
      format: accountDateFormat.toUpperCase(),
      buttons: {
        showClose: true
      },
    })

    $(this.eventStartDateTarget).off('hide.datetimepicker').on('hide.datetimepicker', (ev) => {
      this.timingsTargets[0].dataset.date = this.eventStartDateTarget.querySelector('input').value
      this.removeErrorLabel('#log-starts-at-error')

      $(this.eventEndDateTarget).datetimepicker('minDate', ev.date)
      if (this.eventEndDateTarget.dataset.isEdited === 'false') {
        this.eventEndDateTarget.querySelector('input').value = this.eventStartDateTarget.querySelector('input').value
        this.removeErrorLabel('#log-ends-at-error')
      }

      const activateAtTime = moment(this.activateAtTarget.querySelector('input').value, accountDateFormat.toUpperCase() + ' ' + getTimeFormat(accountIsUseAmPm))
      const eventStartDate = moment(this.eventStartDateTarget.querySelector('input').value, accountDateFormat.toUpperCase())
      $(this.activateAtTarget).datetimepicker('maxDate', eventStartDate.endOf('day'))
      if (this.activateAtTarget.dataset.isEdited === 'false' || activateAtTime.isAfter(eventStartDate)) {
        this.activateAtTarget.querySelector('input').value = this.eventStartDateTarget.querySelector('input').value + (accountIsUseAmPm ? ' 12:00 am' : ' 00:00')
        this.removeErrorLabel('#log-activate-at-error')
      }

      if (this.eventStartDateTarget.querySelector('input').value && this.eventEndDateTarget.querySelector('input').value) {
        this.handleDateChange()
      }
    })
  }

  setupEndDatePicker () {
    this.eventEndDateTarget.dataset.isEdited = 'false'

    const startDate = $(this.eventStartDateTarget).datetimepicker('viewDate')
    $(this.eventEndDateTarget).datetimepicker({
      focusOnShow: false,
      toolbarPlacement: 'bottom',
      format: accountDateFormat.toUpperCase(),
      buttons: {
        showClose: true
      }
    })

    $(this.eventEndDateTarget).datetimepicker('minDate', startDate ? startDate : undefined)

    $(this.eventEndDateTarget).off('hide.datetimepicker').on('hide.datetimepicker', () => {
      this.eventEndDateTarget.dataset.isEdited = 'true'
      this.removeErrorLabel('#log-ends-at-error')

      if (this.eventStartDateTarget.querySelector('input').value && this.eventEndDateTarget.querySelector('input').value) {
        this.handleDateChange()
      }
    })
  }

  setupActivateAtDateTimePicker () {
    this.activateAtTarget.dataset.isEdited = 'false'
    $(this.activateAtTarget).datetimepicker({
      focusOnShow: false,
      toolbarPlacement: 'bottom',
      format: accountDateFormat.toUpperCase() + ' ' + getTimeFormat(accountIsUseAmPm),
      buttons: {
        showClose: true
      },
    })

    $(this.activateAtTarget).off('hide.datetimepicker').on('hide.datetimepicker', () => {
      this.activateAtTarget.dataset.isEdited = 'true'
      this.removeErrorLabel('#log-activate-at-error')
    })
  }

  removeErrorLabel (target) {
    const errorLabel = document.querySelector(target)
    if (errorLabel) {
      errorLabel.classList.remove('error')
      errorLabel.classList.add('d-none')
    }
  }

  connect () {
    if (this.hasEventStartDateTarget) {
      this.setupStartDatePicker()
    }

    if (this.hasEventEndDateTarget) {
      this.setupEndDatePicker()
    }

    if (this.hasActivateAtTarget) {
      this.setupActivateAtDateTimePicker()
    }

    if (this.hasApplyToAllDaysCheckboxTarget) {
      $(this.applyToAllDaysCheckboxTarget).checkbox({
        onChecked: () => {
          dispatchCustomEvent('timings:isApplyToAllDays', { isApplyToAllDays: true })
          this.isRepeatTimingsValue = true
          this.updateTimings(1)
        },
        onUnchecked: () => {
          dispatchCustomEvent('timings:isApplyToAllDays', { isApplyToAllDays: false })
          this.isRepeatTimingsValue = false
          this.updateTimings(this.element.dataset.numberOfDays)
        }
      })
    }
  }

  updateTimings (desiredTimingsCount) {
    const originalTimings = this.timingsTargets[0]
    const originalDropdowns = originalTimings.querySelectorAll('.log-event-select')

    const startMoment = moment(this.eventStartDateTarget.querySelector('input').value, accountDateFormat.toUpperCase())
    const fragment = document.createDocumentFragment()

    const dropdownsToSet = []
    for (let day = 0; day < desiredTimingsCount; day++) {
      const newTimings = originalTimings.cloneNode(true)
      newTimings.dataset.day = day
      newTimings.dataset.date = startMoment.clone().add(day, 'days').format(accountDateFormat.toUpperCase())
      newTimings.querySelector('h3').textContent = 'Timings for ' + newTimings.dataset.date

      newTimings.querySelectorAll('.datetimepicker').forEach((datetimepicker, i) => {
        const newId = 'datetimepicker-day-' + day + '-timing-' + i
        datetimepicker.setAttribute('id', newId)
        datetimepicker.querySelectorAll('.datetimepicker-input').forEach((input) => {
          input.dataset.target = '#' + newId
        })
      })

      const newDropdowns = newTimings.querySelectorAll('.log-event-select')
      newDropdowns.forEach((dropdown, index) => {
        const originalValue = $(originalDropdowns[index]).dropdown('get value')
        dropdownsToSet.push({ dropdown, value: originalValue })
      })

      fragment.appendChild(newTimings)
    }

    this.timingsTargets.forEach((timing) => {
      timing.remove()
    })
    this.element.appendChild(fragment)

    dropdownsToSet.forEach(({ dropdown, value }) => {
      $(dropdown).dropdown()
      $(dropdown).dropdown('set value', value)
    })

    this.updateTimingHeaders()
  }

  updateTimingHeaders () {
    if (this.eventStartDateTarget.querySelector('input').value !== this.eventEndDateTarget.querySelector('input').value) {
      if (this.isRepeatTimingsValue) {
        this.timingsTargets[0].querySelector('h3').textContent = 'Timings for all days from ' + this.eventStartDateTarget.querySelector('input').value + ' to ' + this.eventEndDateTarget.querySelector('input').value
      } else {
        this.timingsTargets.forEach((timing) => {
          timing.querySelector('h3').textContent = 'Timings for ' + timing.dataset.date
        })
      }
    } else {
      this.timingsTargets[0].querySelector('h3').textContent = 'Timings'
    }
  }

  handleDateChange () {
    if (this.eventStartDateTarget.querySelector('input').value !== this.eventEndDateTarget.querySelector('input').value) {
      this.applyToAllDaysTarget.classList.remove('d-none')
      this.applyToAllDaysTarget.classList.add('d-flex')
      this.element.dataset.numberOfDays = moment(this.eventEndDateTarget.querySelector('input').value, accountDateFormat.toUpperCase()).diff(moment(this.eventStartDateTarget.querySelector('input').value, accountDateFormat.toUpperCase()), 'days') + 1

      if (!this.isRepeatTimingsValue) {
        this.updateTimings(this.element.dataset.numberOfDays)
      } else {
        this.updateTimings(1)
      }
    } else {
      this.element.dataset.numberOfDays = 1
      this.timingsTargets[0].querySelector('h3').textContent = 'Timings'
      this.applyToAllDaysTarget.classList.add('d-none')
      this.applyToAllDaysTarget.classList.remove('d-flex')
      this.updateTimings(1)
    }
  }

  get numberOfDays () {
    return this.element.dataset.numberOfDays ?? null
  }

  get isRepeatTimings () {
    return this.isRepeatTimingsValue
  }
}
